window.addEventListener('scroll', function(){
    const navbar = document.querySelector('.banner');

    if(!window.scrollY==0) return navbar.classList.add('blueModeBar');
    navbar.classList.remove('blueModeBar');

  });